import type { ComponentProps } from "react";
import { Theme, YStack } from "tamagui";

import TemplatedDialog from "@/components/templates/dialog";
import { useUserProgression } from "./UserProgressionContext";

export type DialogVariant = "default" | "minimal";

export type UserProgressionScreenWrapperProps = Omit<
  ComponentProps<typeof TemplatedDialog.Content>,
  "progress"
> & {
  dialogVariant?: DialogVariant;
};

const UserProgressionScreenWrapper = ({
  children,
  dialogVariant = "default",
  variant,
  onClose,
  showBackButton,
  onBackPress,
  backButtonDisabled,
  hideCloseButton,
  dataTrackingIdPrefix,
  ...contentProps
}: UserProgressionScreenWrapperProps) => {
  const ctx = useUserProgression();
  const { completed_count, total_count } = ctx?.progression?.progress || {};

  const progressValue =
    total_count && total_count > 0
      ? ((completed_count ?? 0) / total_count) * 100
      : 0;

  if (dialogVariant === "minimal") {
    return (
      <Theme name={variant === "clinical" ? "clinic" : undefined}>
        <YStack flex={1} borderRadius="$150">
          <TemplatedDialog.Controls
            position="absolute"
            width="100%"
            paddingTop="$200"
            paddingHorizontal="$200"
            zIndex={1}
            onClose={onClose}
            showBackButton={showBackButton}
            onBackPress={onBackPress}
            backButtonDisabled={backButtonDisabled}
            hideCloseButton={hideCloseButton}
            dataTrackingIdPrefix={dataTrackingIdPrefix}
          />
          {children}
        </YStack>
      </Theme>
    );
  }

  return (
    <TemplatedDialog.Content
      {...contentProps}
      variant={variant}
      onClose={onClose}
      showBackButton={showBackButton}
      onBackPress={onBackPress}
      backButtonDisabled={backButtonDisabled}
      hideCloseButton={hideCloseButton}
      dataTrackingIdPrefix={dataTrackingIdPrefix}
      progress={{ value: progressValue }}
    >
      {children}
    </TemplatedDialog.Content>
  );
};

export default UserProgressionScreenWrapper;
